import { focusBorder } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { colors } = theme;

export const backToTopButton = css`
  background-color: ${colors.white};
  border-radius: ${pxToRem(6)};
  bottom: ${pxToRem(15)};
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(4)} 0 rgba(0, 0, 0, 0.2);
  height: ${pxToRem(48)};
  left: 100%;
  margin-right: ${pxToRem(10)};
  padding: ${pxToRem(12)};
  position: sticky;

  width: ${pxToRem(48)};
  transition: visibility 0.2s ease, opacity 0.4s ease, transform 0.2s ease,
    background-color 0.3s ease;

  ${/*Visibility to prevent tabbing onto the button, after it is faded out with opacity */ ''}
  opacity: 0;
  visibility: hidden;

  &[data-is-visible='true'] {
    opacity: 1;
    visibility: visible;
  }

  ${/* Prevent icon dragging when click-dragging the button*/ ''}
  img {
    pointer-events: none;
  }

  &:hover,
  &:active {
    background-color: ${colors.bluePattens};
  }

  &:active {
    padding: ${pxToRem(8)};
    transform: scale(0.83);
  }

  &.focus-visible:focus {
    ${/* override default focus styles */ ''}
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(4)} 0 rgba(0, 0, 0, 0.2);

    &::before,
    &::after {
      content: '';
      position: absolute;

      ${/* Render the border away from the button, to create a gap between the button and border */ ''}
      top: ${pxToRem(-4)};
      bottom: ${pxToRem(-4)};
      left: ${pxToRem(-4)};
      right: ${pxToRem(-4)};
      border-radius: ${pxToRem(10)};
      ${focusBorder}
    }
  }
`;
